import { Navigate, useRoutes } from "react-router-dom";
// auth
import AuthGuard from "../auth/AuthGuard";
import GuestGuard from "../auth/GuestGuard";
// layouts
import CompactLayout from "../layouts/compact";
import DashboardLayout from "../layouts/dashboard";
// config
import { useEffect } from "react";
import { useSnackbar } from "../components/snackbar";
import { PATH_AFTER_LOGIN } from "../config-global";
import LandingPage from "../pages/LandingPage";
import LoginPage from "../pages/LoginPage";
import Page404 from "../pages/Page404";
import Profile from "../pages/general/Profile";
import { fetchCategories } from "../redux/slices/category";
import { fetchSize } from "../redux/slices/size";
import { fetchTypes } from "../redux/slices/type";
import { useDispatch } from "../redux/store";
import {
  CategoryList,
  ContactList,
  CreateCategory,
  CreateContact,
  CreateDress,
  CreateHouse,
  CreateOrder,
  CreateProduct,
  CreateSchool,
  CreateSize,
  CreateType,
  CreateUser,
  DressList,
  HouseList,
  OrderList,
  ProductList,
  SchoolList,
  SizeList,
  TypeList,
  UserList,
  ViewEditDress,
  ViewEditOrder,
  ViewEditProduct,
  ViewEditSchool,
} from "./elements";
//

// ----------------------------------------------------------------------

export default function Router() {
  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();

  useEffect(() => {
    dispatch(fetchCategories({ enqueueSnackbar }));
    dispatch(fetchSize({ enqueueSnackbar }));
    dispatch(fetchTypes({ enqueueSnackbar }));
  }, [dispatch]);

  return useRoutes([
    {
      path: "/",
      children: [
        { element: <Navigate to={PATH_AFTER_LOGIN} replace />, index: true },
        {
          path: "login",
          element: (
            <GuestGuard>
              <LoginPage />
            </GuestGuard>
          ),
        },
      ],
    },
    {
      path: "/",
      children: [
        { element: <Navigate to={PATH_AFTER_LOGIN} replace />, index: true },
        // {
        //   path: "privacy-policy",
        //   element: (
        //     <GuestGuard>
        //       <ViewPrivacyPolicy />
        //     </GuestGuard>
        //   ),
        // },
      ],
    },
    {
      path: "/admin",
      element: (
        <AuthGuard>
          <DashboardLayout />
        </AuthGuard>
      ),
      children: [
        { element: <Navigate to={PATH_AFTER_LOGIN} replace />, index: true },
        { path: "dashboard", element: <LandingPage /> },
        {
          path: "profile",
          element: <Profile />,
        },

        // TODO: Entries section

        // TODO: school
        {
          path: "entries/schools",
          children: [
            {
              element: <Navigate to="/admin/entries/schools/" replace />,
              index: true,
            },
            { path: "list", element: <SchoolList /> },
            { path: "add", element: <CreateSchool /> },
            {
              path: "view/:slug",
              element: <ViewEditSchool isEdit={false} view={true} />,
            },
            { path: "edit/:slug", element: <ViewEditSchool isEdit={true} /> },
          ],
        },

        // TODO: dress
        {
          path: "entries/dresses",
          children: [
            {
              element: <Navigate to="/admin/entries/dresses/" replace />,
              index: true,
            },
            { path: "list", element: <DressList /> },
            { path: "add", element: <CreateDress /> },
            {
              path: "view/:slug",
              element: <ViewEditDress isEdit={false} view={true} />,
            },
            { path: "edit/:slug", element: <ViewEditDress isEdit={true} /> },
          ],
        },

        // TODO: size
        {
          path: "entries/sizes",
          children: [
            {
              element: <Navigate to="/admin/entries/sizes/" replace />,
              index: true,
            },
            { path: "list", element: <SizeList /> },
            { path: "add", element: <CreateSize /> },
          ],
        },

        // TODO: categories
        {
          path: "entries/categories",
          children: [
            {
              element: <Navigate to="/admin/entries/categories/" replace />,
              index: true,
            },
            { path: "list", element: <CategoryList /> },
            { path: "add", element: <CreateCategory /> },
          ],
        },

        // TODO: houses
        {
          path: "entries/houses",
          children: [
            {
              element: <Navigate to="/admin/entries/houses/" replace />,
              index: true,
            },
            { path: "list", element: <HouseList /> },
            { path: "add", element: <CreateHouse /> },
          ],
        },


        // TODO: types
        {
          path: "entries/types",
          children: [
            {
              element: <Navigate to="/admin/entries/types/" replace />,
              index: true,
            },
            { path: "list", element: <TypeList /> },
            { path: "add", element: <CreateType /> },
          ],
        },

        // TODO: products
        {
          path: "products",
          children: [
            {
              element: <Navigate to="/admin/products/" replace />,
              index: true,
            },
            { path: "list", element: <ProductList /> },
            { path: "add", element: <CreateProduct /> },
            {
              path: "view/:slug",
              element: <ViewEditProduct isEdit={false} view={true} />,
            },
            { path: "edit/:slug", element: <ViewEditProduct isEdit={true} /> },
          ],
        },

        // TODO: orders
        {
          path: "orders",
          children: [
            {
              element: <Navigate to="/admin/orders/" replace />,
              index: true,
            },
            { path: "list", element: <OrderList /> },
            { path: "add", element: <CreateOrder /> },
            {
              path: "view/:slug",
              element: <ViewEditOrder isEdit={false} view={true} />,
            },
            { path: "edit/:slug", element: <ViewEditOrder isEdit={true} /> },
          ],
        },

        // TODO: contacts
        {
          path: "contacts",
          children: [
            {
              element: <Navigate to="/admin/contacts/" replace />,
              index: true,
            },
            { path: "list", element: <ContactList /> },
            { path: "add", element: <CreateContact /> },
          ],
        },

        // TODO: users
        {
          path: "users",
          children: [
            {
              element: <Navigate to="/admin/users/" replace />,
              index: true,
            },
            { path: "list", element: <UserList /> },
            { path: "add", element: <CreateUser /> },
          ],
        },
      ],
    },

    {
      element: <CompactLayout />,
      children: [{ path: "404", element: <Page404 /> }],
    },

    { path: "*", element: <Navigate to="/404" replace /> },
  ]);
}
